<template>
  <div :class="['row', {'odd': ((place+startIndex) % 2) == 1}]">
    <div class="col place">
      {{place+startIndex}}<sup>th</sup>
    </div>
    <div class="mobile-break"></div>
    <div class="col name">
      <div
        class="avatar"
        :style="`background: url(${avatarUrl}); background-size: cover; background-position: center;`"
      >
      </div>
      {{team.teamName}}
    </div>
    <div class="col score">
      <div class="mobile-label">TOTAL</div>
      <span>
        {{(team.total > 0 && team.total !== 999) && $store.state.game.showPlusSigns ? '+' : ''}}{{cleanScore(team.total)}}
      </span>
    </div>
    <div class="col score">
      <div class="mobile-label">THRU</div>
      <span>{{team.thru}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScoreRow',
  props: {
    team: Object,
    place: Number,
    startIndex: Number,
  },
  mounted() {
    console.log(this.$store.state.game);
  },
  computed: {
    avatarUrl() {
      if (this.team && this.team.avatar && this.team.avatar.avatar) {
        return this.team.avatar.avatar.thumb;
      }
      return '';
    },
  },
  methods: {
    roundScore(score) {
      if (score >= 0) {
        return Math.floor(score);
      }
      return Math.ceil(score);
    },
    cleanScore(score) {
      let value = '';
      if (score === null || score === 999) {
        value = '';
      } else if (score === 0) {
        value = 'E';
      } else if (this.$store.state.game.roundScores) {
        value = this.roundScore(score);
      } else {
        value = score;
      }
      return value;
    },
  },
};
</script>
<style lang="scss" scoped>
  @mixin mobile {
    @media (max-width: 800px) { @content; }
  }
  .row{
    color: white;
    display: flex;
    background: #3E3E3E;

    @include mobile{
      flex-wrap: wrap;
      padding: 1rem;
    }

    &.odd{
      background: #707070;
    }
  }

  .place{
    font-size: 2.5rem;
    font-weight: bold;
    justify-content: center;
    text-align: center;
    width: 10rem;
    sup{
      position: relative; top: -0.25em; font-size: 60%;
    }

    @include mobile{
      font-size: 2rem;
      order: 3;
    }
  }

  .name{
    font-size: 1.75rem;
    font-style: italic;

    @include mobile {
      order: 1;
      font-size: 1.25rem;
      width: 100%;
      padding-bottom: 1rem;
    }
  }

  .mobile-label{
    display: none;
    @include mobile{
      display: block;
      font-size: .9rem;
      opacity: .6;
    }
  }

  .mobile-break{
    display: none;
    @include mobile{
      display: block;
      flex-basis: 100%;
      width: 0;
      order: 2;
    }
  }

  .score{
    font-size: 2rem;
    justify-content: center;
    width: 8rem;
    @include mobile{
      order: 4;
      font-size: 1.25rem;
      display: flex;
      flex-direction: column;
    }
  }

  .col{
    display: flex;
    align-items: center;
    margin-right: 1rem;

    @include mobile{
      flex: 1;
    }

    &.name{
      flex: 1;
    }
    &:last-child{
      margin-right: 0;
    }
  }

  .avatar{
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 2rem;

    @include mobile{
      width: 60px;
      height: 60px;
      margin-right: 1rem;
    }
  }
</style>
